import axios from '../axios/index.js'
export default {


  getNewsList(params) {
    return axios('/api/tonggw/information/page', {
      params
    })
  },
  getNewsDetails(id) {
    return axios('/api/tonggw/information/'+id)
  },
  submitMessage(params) {
    return axios({url:'/api/tonggw/consult/add',method:'post',data:params})
  },
  getAgreement(type) {
    return axios(`https://app.tongctec.com/api/tongapp/agreement?type=${type}`)
  },
}
